import { useMutation } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { BaseText, BottomButtonsLayout, Button, FieldInput } from 'aimo-ui';
import { showToast } from 'components/common/CustomToast';
import AccountContext from 'context/AccountContext';
import { CREATE_PERMIT_APPLICATION } from 'graphql/mutations/createPermitApplication';
import useCreateApplicationInputFactory from 'hooks/useCreateApplicationInputFactory';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';
import { MainWrapper } from 'styles/ModalStackContainerStyles';
import {
  Mutation,
  MutationCreatePermitApplicationArgs,
} from 'types/generatedSchemaTypes';
import { RootStackParamList } from 'types/navigation';
import { getCustomerAddress } from 'utils/cityParkingUtils';

const StyledBaseText = styled(BaseText)`
  flex-shrink: 1;
`;

const CityParkingApplyScreen: React.FC = () => {
  const [rationale, setRationale] = useState('');
  const { customer } = useContext(AccountContext);
  const { t } = useTranslation();
  const { replace } = useNavigation<StackNavigationProp<RootStackParamList>>();
  const createApplicationInput = useCreateApplicationInputFactory(rationale);
  const [createPermitApplication, { loading }] = useMutation<
    Mutation,
    MutationCreatePermitApplicationArgs
  >(CREATE_PERMIT_APPLICATION, {
    onCompleted: () => {
      replace('mainTabs', {
        screen: 'servicesScreen',
        params: {
          screen: 'servicesMain',
        },
      });
    },
    onError: () => showToast('error.applicationCreationFailed', 'error'),
  });

  const sendApplication = () => {
    createPermitApplication({ variables: { input: createApplicationInput() } });
  };

  const addressString = getCustomerAddress(customer?.strongAuthentication);

  return (
    <MainWrapper>
      <BottomButtonsLayout
        contentBottom={
          <Button
            loading={loading}
            disabled={rationale.length < 10 || loading}
            size="l"
            onPress={sendApplication}
            text={t('button.send')}
            testID="street-parking-apply-send"
          />
        }>
        <StyledWrapper maxWidth={300} center mb={25}>
          <BaseText>
            {t('cityPermits.applicationMainText', { addressString })}
          </BaseText>
        </StyledWrapper>
        <StyledWrapper maxWidth={300} center mb={25}>
          <StyledBaseText>{t('cityPermits.neededDocuments')}</StyledBaseText>
        </StyledWrapper>
        <StyledWrapper maxWidth={300} center mb={45}>
          <BaseText>{t('cityPermits.orApplyNow')}</BaseText>
        </StyledWrapper>
        <FieldInput
          value={rationale}
          title={t('cityPermits.applicationRationale')}
          onChangeText={setRationale}
          testID="city-pmc-apply-input"
        />
      </BottomButtonsLayout>
    </MainWrapper>
  );
};

export default CityParkingApplyScreen;
